import * as React from 'react';
import { IConfig } from '@cian/config/shared';

import { useHeaderDesktopHeightCssVariable, useOpenZhkCardUxfbEvent } from './hooks';

interface IAppEffectsProps {
  config: IConfig;
}

export const AppEffects: React.FC<IAppEffectsProps> = ({ config }) => {
  useHeaderDesktopHeightCssVariable();
  useOpenZhkCardUxfbEvent(config);

  return null;
};
